import axios from "@/axios.js";

export default {
  addItem({ commit }, item) {
    return new Promise((resolve, reject) => {
      debugger;
      axios
        .post("API/PaymentTypes/AddPaymentType", item)
        .then(response => {
          debugger;
          resolve(response);
          commit(
            "ADD_ITEM",
            Object.assign(item, { ID: response.data.data.ID })
          );
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  fetchDataListItems({ commit }) {
    debugger;
    return new Promise((resolve, reject) => {
      axios
        .get("API/PaymentTypes/GetAllPaymentType")
        .then(response => {
          debugger;
          resolve(response);
          commit("SET_PaymentType", response.data.data);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  updateItem({commit}, item) {
    debugger;
    return new Promise((resolve, reject) => {
      axios
        .put("API/PaymentTypes/UpdatePaymentType", item)
        .then(response => {
          resolve(response);
          commit("UPDATE_PaymentType", response.data.data);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  GetItemByID(context, itemid) {
    return new Promise((resolve, reject) => {
      debugger;
      axios
      .get("API/PaymentTypes/GetPaymentTypeById?Id=" + itemid)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  GetUnitPayments(context, itemid) {
    return new Promise((resolve, reject) => {
      debugger;
      axios
      .get("API/PaymentTypes/GetUnitPayments?Id=" + itemid)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },


  DeleteObject({ commit }, item) {
    debugger;
    return new Promise((resolve, reject) => {
      axios
        .delete("API/PaymentTypes/DeletePaymentType?Id=" + item.id)
        .then(response => {
          resolve(response);
          commit("REMOVE_ITEM", item.id);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

};
